<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'set_password_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'drivers.username' | translate }}</span>
      <input type="text" [value]="username" disabled />
    </label>
    <label class="password-field">
      <span>{{ 'set_password_dialog.password' | translate }}</span>
      <div class="input-with-icon">
        <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" />
        <button type="button" class="icon-button" (click)="toggleShowPassword()" [attr.aria-label]="(showPassword ? 'set_password_dialog.hide' : 'set_password_dialog.show') | translate">
          <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
    </label>
    <div class="error" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'set_password_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting">{{ 'set_password_dialog.submit' | translate }}</button>
  </div>
</div>


